import React, { ReactNode, createContext, useContext, useState } from 'react';
import * as vp from 'vopay';

export type IQ11UserData = {
  clientAccount: vp.IQ11AuthorizationClientAccount | undefined;
  jwt: string;
  loginUserEmail: string;
};
export type IQ11UserDataCtx = {
  response: {
    clientAccount: vp.IQ11AuthorizationClientAccount | undefined;
    jwt: string;
    loginUserEmail: string;
  };
  setIQ11UserData: (iq11UserData: IQ11UserData) => void;
  reset: () => void;
};

export const IQ11UserDataContext = createContext<IQ11UserDataCtx>({
  response: {
    clientAccount: {
      BusinessName: '',
      ClientAccountID: '',
      ClientDisplayName: '',
      ClientType: '',
      DateAdded: '',
      DateDeleted: '',
      EmailAddress: '',
      FirstName: '',
      LastName: '',
      IPAddress: '',
      IsActive: '',
      IsPrimaryAccount: '',
      LastModified: '',
      TransactionLimit: '',
      ID: 0,
      VIOClientAccountUsers_ID: 0,
      VIOAccounts_ID: 0,
      IsBillingAccount: '',
    },
    jwt: '',
    loginUserEmail: '',
  },
  setIQ11UserData: () => {},
  reset: () => {},
});

export const IQ11UserDataProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [iq11userData, setIQ11UserData] = useState<IQ11UserData>({
    clientAccount: {
      BusinessName: '',
      ClientAccountID: '',
      ClientDisplayName: '',
      ClientType: '',
      DateAdded: '',
      DateDeleted: '',
      EmailAddress: '',
      FirstName: '',
      LastName: '',
      IPAddress: '',
      IsActive: '',
      IsPrimaryAccount: '',
      LastModified: '',
      TransactionLimit: '',
      ID: 0,
      VIOClientAccountUsers_ID: 0,
      VIOAccounts_ID: 0,
      IsBillingAccount: '',
    },
    jwt: '',
    loginUserEmail: '',
  });

  return (
    <IQ11UserDataContext.Provider
      value={{
        response: iq11userData,
        setIQ11UserData,
        reset: () =>
          setIQ11UserData({
            clientAccount: {
              BusinessName: '',
              ClientAccountID: '',
              ClientDisplayName: '',
              ClientType: '',
              DateAdded: '',
              DateDeleted: '',
              EmailAddress: '',
              FirstName: '',
              LastName: '',
              IPAddress: '',
              IsActive: '',
              IsPrimaryAccount: '',
              LastModified: '',
              TransactionLimit: '',
              ID: 0,
              VIOClientAccountUsers_ID: 0,
              VIOAccounts_ID: 0,
              IsBillingAccount: '',
            },
            jwt: '',
            loginUserEmail: '',
          }),
      }}
    >
      {children}
    </IQ11UserDataContext.Provider>
  );
};

export const useIQ11UserData = (): IQ11UserDataCtx => useContext(IQ11UserDataContext);
